module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfesignup_remoteEntry_mjs_ebeebb3b__;